import React from 'react';
import { motion } from 'framer-motion';

const BreakFree = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
  };

  return (
    <section className="story-solution-section">
      <div className="solution-content-wrapper glass-container">
        <motion.div 
          className="solution-main-heading"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>But what if you could <span className="highlight-text-primary">break free?</span></h2>
        </motion.div>

        <motion.div 
          className="solution-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {/* Left Column - Questions */}
          <motion.div className="solution-card glass-panel questions-card" variants={itemVariants}>
            <div className="card-header">
              <h3>Imagine if...</h3>
            </div>
            <div className="question-list">
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>You <strong className="text-primary">owned your CRM</strong>—completely</p>
              </div>
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>It was built around <strong className="text-primary">YOUR process</strong>, not theirs</p>
              </div>
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>Growing your team didn't mean growing your monthly bill</p>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Promise */}
          <motion.div className="solution-card glass-panel promise-card" variants={itemVariants}>
            <div className="promise-header">
              <h3>That's not a fantasy.<br/><span className="accent-red">That's what we build.</span></h3>
            </div>
            <ul className="benefits-grid">
              <li>
                <span className="benefit-icon">✓</span>
                <span>A custom CRM designed for your exact workflow</span>
              </li>
              <li>
                <span className="benefit-icon">✓</span>
                <span>Built on open-source foundations you control</span>
              </li>
              <li>
                <span className="benefit-icon">✓</span>
                <span>One investment. Zero subscriptions. Infinite possibilities</span>
              </li>
            </ul>
          </motion.div>
        </motion.div>

        {/* Bottom - No More Section */}
        <motion.div 
          className="solution-no-more-section glass-panel"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h4>Say goodbye to:</h4>
          <div className="no-more-grid">
            <motion.div className="no-more-item glass-item" whileHover={{ scale: 1.05, y: -5 }}>
              <span className="x-icon">✕</span>
              <p>Bending your business to fit someone else's template</p>
            </motion.div>
            <motion.div className="no-more-item glass-item" whileHover={{ scale: 1.05, y: -5 }}>
              <span className="x-icon">✕</span>
              <p>Paying rent on software you'll never truly own</p>
            </motion.div>
            <motion.div className="no-more-item glass-item" whileHover={{ scale: 1.05, y: -5 }}>
              <span className="x-icon">✕</span>
              <p>Choosing between growth and cost control</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div 
          className="solution-final-statement glass-panel highlight-border"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <p>Your business deserves better. <strong className="text-primary">Let's build something that actually works for you.</strong></p>
        </motion.div>
      </div>
    </section>
  );
};

export default BreakFree;
